import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as async from "async";
import BookModel from "models/BookModel";
import Shelf from "models/ShelfModel";
import models from "models/models";
import * as mustcache from "mustcache";
import readlangClient from "readlangClient";
import PublicLibraryListView from "views/PublicLibraryListView";

let element;
let renderedCallback;
let appRouter;
let options;
let pageName = "publicShelfPage";
let initialized = false;

export const name = pageName;

const onChange = () => {
  if ($("body").attr("id") === pageName) {
    render(element, renderedCallback, appRouter, options);
  }
};

export const render = (_element, _renderedCallback, _appRouter, _options) => {
  element = _element;
  renderedCallback = _renderedCallback;
  appRouter = _appRouter;
  options = _options;

  if (!initialized) {
    models.user.on("change", onChange);
    initialized = true;
  }

  element.empty();

  const libraryHeader = $("<div/>");
  const libraryElement = $("<div/>");

  element.append(libraryHeader);
  element.append(libraryElement);
  element.append('<div style="clear:both;margin-bottom:20px"/>');

  localStorage.setItem("libraryOrDashboardPath", "/shelf/" + options.shelfID);

  async.parallel(
    [
      (cb) => {
        readlangClient.request(
          "GET",
          "/api/shelf/" + options.shelfID,
          {},
          (result) => {
            const shelf = new Shelf(result).viewJSON();

            $("title").text(shelf.name + " - Readlang");
            $('meta[name="description"]').text(shelf.description);

            shelf.bookCount = shelf.books.length;
            shelf.textsString = shelf.bookCount === 1 ? "text" : "texts";
            mustcache.render("publicShelfHeader", { shelf }, (html) => {
              libraryHeader.html(html);

              if (
                shelf.language &&
                models.user.get("currentLearningLanguage") !== shelf.language
              ) {
                models.user.save(
                  { currentLearningLanguage: shelf.language },
                  { patch: true }
                );
              }
              cb();
            });
          },
          () => {
            element.text("Shelf not found or is no longer public.");
            // @ts-ignore
            cb("abort");
          }
        );
      },
      (cb) => {
        readlangClient.request(
          "GET",
          "/api/books",
          {
            shelfID: options.shelfID,
          },
          (books) => {
            const booksCollection = new Backbone.Collection(
              _.map(books, (book) => {
                const bookModel = new BookModel(book);
                bookModel.populateExtraFields(models, true);
                return bookModel;
              }),
              { idAttribute: "_id" }
            );

            // XXX Manage subviews?
            new PublicLibraryListView({
              collection: booksCollection,
              models: models,
              el: libraryElement,
              // @ts-ignore
              appRouter: appRouter,
              rendered: cb,
            });
          },
          () => {
            console.log("error finding books");
            // @ts-ignore
            cb("abort");
          }
        );
      },
    ],
    () => {
      renderedCallback();
    }
  );
};

export const close = () => {};
export const showHeader = true;
